export const DevelopmentServicesContentArabic = {
    DevelopmentServicesWebPageHeading: "مجموعتنا الواسعة من خدمات تطوير تطبيقات الويب الشاملة",
    DevelopmentServicesWebPageDescription: "تغطي حلول تطبيقات الويب لدينا كل شيء، بدءًا من منصات السحابة المخصصة والبوابات التفاعلية، وصولًا إلى تطوير واجهة أمامية سلسة وواجهة خلفية قوية. نقدم حلولًا آمنة وقابلة للتطوير مصممة لتتطور مع تطور أعمالكم، بما في ذلك الاستشارات المتخصصة والدعم المستمر."
}

export const DevelopmentServicesDataArabic = [
    {
        id: "Tab1",
        label: "تطوير بوابات الويب",
        content: "عزّز عملك من خلال خدمات تطوير بوابات الويب المخصصة لدينا. نحن نبني بوابات قابلة للتطوير وآمنة وتفاعلية تعمل على تحسين سير العمل، وتحسين التعاون، وتبسيط العمليات. تضمن حلولنا وصولاً سلسًا إلى البيانات والأتمتة ومشاركة المستخدم عبر الصناعات.",
        secondContent: "من بوابات المؤسسات إلى منصات الخدمة الذاتية، يقدم فريقنا بوابات ويب غنية بالميزات وعالية الأداء مصممة خصيصًا لاحتياجاتك. استفد من أحدث التقنيات لتعزيز الكفاءة وإنشاء تجربة رقمية مركزية لمستخدميك.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab3",
        label: "خدمات تطوير تطبيقات SaaS",
        content: "باستخدام خدمات تطوير تطبيقات SaaS المتطورة لدينا، نقوم بتصميم وبناء تطبيقات SaaS قابلة للتطوير وآمنة وسهلة الاستخدام تلبي احتياجات عملك الخاصة. من البنية متعددة المستأجرين إلى التحديثات السلسة، يضمن تطوير تطبيقات SaaS لدينا تميز الحل الخاص بك في السوق التنافسية.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab4",
        label: "تطوير تطبيقات الويب للواجهة الأمامية (Frontend)",
        content: "قدم تطبيقات ويب مذهلة وعالية الأداء من خلال خدمات تطوير الواجهة الأمامية المتخصصة لدينا. نحن ننشئ واجهات بديهية وسهلة الاستخدام باستخدام أطر عمل حديثة مثل React و Angular و Vue.js، مما يضمن تجارب سلسة عبر الأجهزة.",
        secondContent: "يتخصص فريقنا في حلول الواجهة الأمامية سريعة التحميل والتفاعلية والقابلة للتطوير التي تعزز مشاركة المستخدم والأداء. سواء كنت تقوم ببناء تطبيق ويب تقدمي (PWA) أو منصة ويب معقدة، فإننا نصمم حلولًا تعطي الأولوية للسرعة والأمان والاستجابة.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab9",
        label: "تطوير تطبيقات الويب للواجهة الخلفية (Backend)",
        content: "ادعم تطبيقات الويب الخاصة بك بواجهة خلفية قوية وقابلة للتطوير وعالية الأداء. يتخصص مطورونا في Node.js و Python و PostgreSQL وتقنيات السحابة، مما يضمن معالجة فعالة للبيانات، ومعالجة في الوقت الفعلي، وتكاملات سلسة.",
        secondContent: "مع التركيز على الأمان والموثوقية وبنية API-driven، ننشئ واجهات خلفية محسّنة تدعم تطبيقات الويب الديناميكية. سواء كنت تتعامل مع أحمال حركة المرور العالية أو منطق العمل المعقد، فإننا نبني حلولًا جاهزة للمستقبل لتعزيز أداء منصتك.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab5",
        label: "استشارات تطبيقات الويب",
        content: "تجاوز تعقيدات تطوير الويب من خلال خدماتنا الاستشارية المتخصصة. نحن نساعد الشركات على اختيار مجموعة التقنيات الصحيحة، والبنية، وبروتوكولات الأمان لضمان النجاح وقابلية التوسع على المدى الطويل.",
        secondContent: "يتخصص مستشارونا في تحسين الأداء، وترحيل السحابة، واستراتيجيات التحول الرقمي. سواء كنت تطلق تطبيق ويب جديدًا أو تقوم بتحسين تطبيق موجود، فإننا نقدم رؤى تعتمد على البيانات وخبرة فنية لتسريع النمو.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab6",
        label: "تطوير تطبيقات الويب المخصصة للمؤسسات",
        content: "حوّل مؤسستك باستخدام تطبيقات ويب مخصصة مصممة للكفاءة والأمان وقابلية التوسع. نحن نبني حلولًا رقمية مصممة خصيصًا تتكامل بسلاسة مع سير العمل الحالي، وبيئات السحابة، والعمليات التجارية.",
        secondContent: "يركز فريق الخبراء لدينا على الأتمتة، ومعالجة البيانات في الوقت الفعلي، والرؤى المدعومة بالذكاء الاصطناعي لتعزيز الإنتاجية. من أنظمة إدارة علاقات العملاء (CRMs) المخصصة إلى أنظمة تخطيط موارد المؤسسات (ERP) المتقدمة، ننشئ تطبيقات على مستوى المؤسسات تدفع الابتكار والميزة التنافسية.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
    {
        id: "Tab7",
        label: "تطوير تطبيقات الويب Headless WordPress",
        content: "أطلق العنان للأداء والمرونة غير المسبوقين من خلال تطوير تطبيقات الويب Headless WordPress. نحن ندمج نظام إدارة المحتوى القوي في WordPress مع أطر عمل الواجهة الأمامية الحديثة مثل React و Next.js، مما يضمن تجربة سريعة البرق ومدفوعة بواجهة برمجة التطبيقات (API).",
        secondContent: "عن طريق فصل الواجهة الخلفية عن الواجهة الأمامية، نقدم تطبيقات ويب مخصصة للغاية وقابلة للتطوير وآمنة. سواء كنت بحاجة إلى منصة غنية بالمحتوى، أو متجر تجارة إلكترونية، أو موقع ويب تسويقي، فإن حلولنا تضمن أداءً محسنًا وتكاملات سلسة مع الجهات الخارجية.",
        btnText: "دعنا نناقش",
        btnLink: "#",
        imgs: [
            {
                img: "/images/services-icons/web-app-development/sql.png",
            },
            {
                img: "/images/services-icons/web-app-development/node.png",
            },
            {
                img: "/images/services-icons/web-app-development/react.png",
            },
            {
                img: "/images/services-icons/web-app-development/keycloak.png",
            },
        ],
    },
];